import type {RowData, TableOptions} from '@tanstack/react-table';
import {
  getCoreRowModel,
  getExpandedRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

export function useTable<TData extends RowData>(
  options: Omit<TableOptions<TData>, 'getCoreRowModel'>
) {
  return useReactTable({
    defaultColumn: {
      sortingFn: 'alphanumeric',
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    globalFilterFn: 'auto',
    enableMultiSort: true,
    ...options,
  });
}
